import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "Progress" }
const _hoisted_2 = { class: "card mb-3" }
const _hoisted_3 = { class: "card-header bg-light" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Students in this Classgroup")
], -1)
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "float-end" }
const _hoisted_8 = {
  class: "form-label pe-2",
  for: "inputWord"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "bi-search fs--1" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "row flex-between-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "align-items-center aling-middle fs--1" }, [
    /*#__PURE__*/_createTextVNode(" Listed students automatically receive a notification only after you have added and excercise to their app. New students added will receive all assignments, old and new. "),
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-info-circle icon-info" })
  ])
], -1)
const _hoisted_12 = ["data-list"]
const _hoisted_13 = { class: "table-responsive scrollbar" }
const _hoisted_14 = { class: "table table-sm fs--1 mb-0 table-hover" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", { class: "text-900" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-props" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-1 align-middle",
      "data-sort": "name"
    }, " Name and Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-1 align-middle"
    }, "Subscribed?"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-1 align-middle"
    }, "Data Privacy"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-1 align-middle",
      "data-sort": "comments"
    }, " Comments "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-1 align-middle",
      "data-sort": "badges_earned"
    }, " Badges earned "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-1 align-middle"
    }, " Assignments made "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "pr-1 align-middle",
      "data-sort": "words"
    }, " Words ")
  ])
], -1)
const _hoisted_16 = { class: "list" }
const _hoisted_17 = { class: "align-middle" }
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = { class: "d-flex flex-column justify-content-between mr-2 w-50" }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = ["textContent"]
const _hoisted_22 = { class: "ml-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "align-middle" }
const _hoisted_25 = { class: "flex-2 ms-3 d-md-none d-lg-block text-table" }
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = ["id", "name"]
const _hoisted_28 = ["for"]
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = ["id", "name"]
const _hoisted_31 = ["for"]
const _hoisted_32 = { class: "align-middle" }
const _hoisted_33 = { class: "flex-2 ms-3 d-md-none d-lg-block text-table" }
const _hoisted_34 = { class: "d-flex justify-content-between" }
const _hoisted_35 = { class: "form-check" }
const _hoisted_36 = ["id", "name"]
const _hoisted_37 = ["for"]
const _hoisted_38 = { class: "form-check" }
const _hoisted_39 = ["id", "name"]
const _hoisted_40 = ["for"]
const _hoisted_41 = { class: "comments align-middle text-center" }
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "comments-icon mr-2 d-none" }, null, -1)
const _hoisted_44 = ["textContent"]
const _hoisted_45 = { class: "badges_earned align-middle text-center" }
const _hoisted_46 = { class: "d-flex" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "badge-icon mr-2" }, null, -1)
const _hoisted_48 = ["textContent"]
const _hoisted_49 = { class: "align-middle text-table" }
const _hoisted_50 = { class: "fs-sm--2" }
const _hoisted_51 = { class: "words align-middle pe-5" }
const _hoisted_52 = ["textContent"]
const _hoisted_53 = { class: "bg-light py-2" }
const _hoisted_54 = { class: "ps-3 float-start" }
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center\"><button class=\"btn btn-sm btn-falcon-default me-1\" type=\"button\" title=\"Previous\" data-list-pagination=\"prev\"><span class=\"fas fa-chevron-left\"></span></button><ul class=\"pagination mb-0\"></ul><button class=\"btn btn-sm btn-falcon-default ms-1\" type=\"button\" title=\"Next\" data-list-pagination=\"next\"><span class=\"fas fa-chevron-right\"></span></button></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ModalCreateStudent = _resolveComponent("ModalCreateStudent")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control fuzzy-search btn-table-header",
                        type: "search",
                        placeholder: "Search Student",
                        "aria-label": "Search Student",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.searchText]
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-primary ml-4 btn-table-header",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filter && _ctx.filter(...args))),
                      type: "submit"
                    }, _hoisted_10)
                  ])
                ])
              ]),
              _hoisted_11
            ]),
            (_ctx.students.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "card-body px-0 py-0",
                  id: "classgroups-students-data-table",
                  "data-list": JSON.stringify(_ctx.dataListOptions)
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("table", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("tbody", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.students, (student) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "btn-reveal-trigger",
                            key: student.id
                          }, [
                            _createElementVNode("td", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("h6", {
                                    class: "mb-0",
                                    textContent: _toDisplayString(student.name)
                                  }, null, 8, _hoisted_20),
                                  _createElementVNode("span", {
                                    class: "pe-3 text-table",
                                    textContent: _toDisplayString(student.email)
                                  }, null, 8, _hoisted_21)
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_Dropdown, {
                                    id: `classgroups-students-dropdown-${student.id}`
                                  }, {
                                    options: _withCtx(() => [
                                      _createVNode(_component_router_link, {
                                        to: {
                                name: 'StudentsDetails',
                                params: {
                                  classgroupId: student.classGroupId,
                                  studentId: student.id,
                                },
                              },
                                        class: "dropdown-item",
                                        textContent: _toDisplayString('Details')
                                      }, null, 8, ["to", "textContent"]),
                                      _createElementVNode("button", {
                                        class: "dropdown-item text-danger",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.deleteClassgroupStudent(student))
                                      }, " Delete ", 8, _hoisted_23)
                                    ]),
                                    _: 2
                                  }, 1032, ["id"])
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    id: `subscribed-yes-${student.id}`,
                                    type: "radio",
                                    name: `subscribed${student.id}`
                                  }, null, 8, _hoisted_27),
                                  _createElementVNode("label", {
                                    class: "fs-sm--2",
                                    for: `subscribed-yes-${student.id}`,
                                    checked: ""
                                  }, "Yes", 8, _hoisted_28)
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    id: `subscribed-no-${student.id}`,
                                    type: "radio",
                                    name: `subscribed${student.id}`
                                  }, null, 8, _hoisted_30),
                                  _createElementVNode("label", {
                                    class: "fs-sm--2",
                                    for: `subscribed-no-${student.id}`
                                  }, "No", 8, _hoisted_31)
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      id: `data-privacy-all${student.id}`,
                                      type: "radio",
                                      name: `data-privacy${student.id}`
                                    }, null, 8, _hoisted_36),
                                    _createElementVNode("label", {
                                      class: "fs-sm--2",
                                      for: `data-privacy-all${student.id}`
                                    }, "All", 8, _hoisted_37)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    id: `data-privacy-assigned${student.id}`,
                                    type: "radio",
                                    name: `data-privacy${student.id}`
                                  }, null, 8, _hoisted_39),
                                  _createElementVNode("label", {
                                    class: "fs-sm--2",
                                    for: `data-privacy-assigned${student.id}`
                                  }, "Assigned", 8, _hoisted_40)
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("span", {
                                  class: "badge rounded-pill-lg badge-soft-info",
                                  textContent: _toDisplayString(student.comments)
                                }, null, 8, _hoisted_44)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("span", {
                                  class: "badge rounded-pill-lg badge-soft-success",
                                  textContent: _toDisplayString(student.badgesEarned)
                                }, null, 8, _hoisted_48)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_49, [
                              _createElementVNode("label", _hoisted_50, _toDisplayString(student.assignmentsCompleted) + " / " + _toDisplayString(student.assignmentsTotal), 1)
                            ]),
                            _createElementVNode("td", _hoisted_51, [
                              _createElementVNode("span", {
                                class: "badge rounded-pill-lg badge-soft-success",
                                textContent: _toDisplayString(student.words)
                              }, null, 8, _hoisted_52)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        class: "btn btn-falcon-primary me-1 mb-1 btn-table-header",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewStudent && _ctx.addNewStudent(...args)))
                      }, " Add + ")
                    ]),
                    _hoisted_55
                  ])
                ], 8, _hoisted_12))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_ModalCreateStudent, {
          id: "create-student-modal",
          ref: "modalCreateStudentContainer",
          classgroupId: _ctx.classgroup.id,
          onClose: _ctx.closeStudentModal
        }, null, 8, ["classgroupId", "onClose"])
      ], 64))
}